var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGnaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 25,
    viewBox: "0 0 83 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_11455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.623 10.7591H26.4543V24.1899H21.7704L20.451 21.5558C18.3179 23.3119 15.6901 24.1899 12.5674 24.1899C10.3464 24.1899 8.30136 23.7888 6.43215 22.9867C4.56298 22.1845 3.02366 20.9271 1.8142 19.2143C0.604733 17.4799 0 15.4419 0 13.1005V11.2794C0 7.7455 1.26444 5.01379 3.79332 3.08425C6.34419 1.15471 9.5768 0.189941 13.491 0.189941C16.6357 0.189941 19.2854 0.818668 21.4405 2.07612C23.6175 3.31189 25.047 5.04631 25.7286 7.27937L18.043 8.74282C17.6912 7.83222 17.0865 7.10593 16.2288 6.56393C15.3932 6.00024 14.4256 5.7184 13.3261 5.7184C11.9627 5.7184 10.8082 6.14116 9.86264 6.98669C8.93904 7.81054 8.47728 9.06802 8.47728 10.7591V13.6534C8.47728 15.2794 8.93904 16.526 9.86264 17.3932C10.8082 18.2604 12.0067 18.694 13.4581 18.694C15.6131 18.694 17.1304 17.6317 18.01 15.507H13.623V10.7591Z",
    fill: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9219 24.1899V0.189941H36.0852L46.3146 11.6756H46.3824V0.189941H54.3762V24.1899H46.484L36.0174 12.3271H35.9158V24.1899H27.9219Z",
    fill: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3157 24.1899L73.4094 21.058H64.2042L63.2411 24.1899H55.8486L64.5441 0.189941H73.8058L82.3026 24.1899H74.3157ZM65.9036 15.407H71.7382L68.9342 5.84101H68.8209L65.9036 15.407Z",
    fill: "var(--primary-color-text)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_11455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.4,
    height: 24,
    fill: "white",
    transform: "translate(0 0.189941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnaLogo);
export default __webpack_public_path__ + "static/media/GNA_Logo.e51e45f244886aa8c14facd687d45b15.svg";
export { ForwardRef as ReactComponent };